import { Card, Typography, Divider, Tag, Spin } from "antd";
import { Bar } from "react-chartjs-2";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../slice";
import * as selectors from "../selectors";
import { useState } from "react";

const { Title, Text } = Typography;

const ReviewReportsStatus = ({ selectedCommodities, dateRange }) => {
  const dispatch = useDispatch();

  const reportReviewStatus = useSelector(selectors.selectReportReviewStatus);
  const [isLoading, setIsLoading] = useState(true);

  const filteredData = reportReviewStatus?.reviewStatusCounts || {};
  
  // Define the desired order of statuses
  const statusOrder = [
    "ProcessingFailed",
    "ReviewPending",
    "ReviewInProgress", 
    "ReviewCompleted",
    "Under Dispute",
  ];
  
  // Create ordered arrays based
  const filteredLabels = statusOrder.filter(status => filteredData[status] !== undefined);
  const filteredValues = filteredLabels.map(status => filteredData[status] || 0);

  const chartData = {
    labels: filteredLabels,
    datasets: [
      {
        label: "Count",
        data: filteredValues,
        backgroundColor: filteredLabels.map(getStatusColor),
        borderRadius: 6,
        maxBarThickness: 100,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { precision: 0 },
        grid: { drawBorder: true },
      },
      x: { grid: { display: false } },
    },
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      actions.getReportReviewStatus({
        selectedCommodities,
        dateRange,
        onSuccess: () => {
          setIsLoading(false);
        },
        onFailure: () => {
          setIsLoading(false);
        },
      })
    );
  }, [dispatch, selectedCommodities, dateRange]);

  return (
    <Card
      style={{
        borderRadius: 8,
        backgroundColor: "#fff",
        marginTop: 24,
      }}
      bodyStyle={{ padding: 24 }}
    >
      {isLoading ? (
        <div
          style={{
            minHeight: 500,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 24,
          }}
        >
          <Spin size="large" />
          <div style={{ marginTop: 12 }}>Loading...</div>
        </div>
      ) : (
        <>
          {/* Title */}
          <Title level={4} style={{ marginBottom: 24 }}>
            Review Reports Status
          </Title>

          {/* Chart */}
          <div style={{ height: 280, marginBottom: 32 }}>
            <Bar data={chartData} options={chartOptions} />
          </div>

          <Divider style={{ margin: "24px 0" }} />

          {/* Latest failed section */}
          {reportReviewStatus?.processingFailedOrders?.length > 0 && (
            <div>
              <Text
                style={{
                  color: "#e53935",
                  fontWeight: 600,
                  fontSize: 15,
                }}
              >
                Latest Processing Failed Orders
              </Text>

              {reportReviewStatus?.processingFailedOrders?.map((order) => (
                <Card
                  key={order._id}
                  size="small"
                  style={{
                    marginTop: 16,
                    borderColor: "#f44336",
                    background: "#fff",
                    borderRadius: 8,
                  }}
                  bodyStyle={{
                    padding: "12px 16px",
                  }}
                >
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <Text strong>Order ID: {order.orderId}</Text>
                        <div style={{ marginTop: 4 }}>
                          <Text>
                            <span style={{ color: "#333", fontWeight: 500 }}>
                              Commodity:
                            </span>{" "}
                            {order.commodityName}
                          </Text>
                        </div>
                        {/* <div style={{ marginTop: 4, color: "#888" }}>
                          Report Upload Date: 16/07/2025
                        </div> */}
                      </div>
                      <Tag
                        color="#f44336"
                        style={{
                          color: "#fff",
                          borderRadius: 20,
                          fontWeight: 500,
                          padding: "2px 12px",
                          fontSize: 13,
                          alignSelf: "center",
                        }}
                      >
                        Processing Failed
                      </Tag>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          )}
        </>
      )}
    </Card>
  );
};

export default ReviewReportsStatus;

const getStatusColor = (status) => {
  switch (status) {
    case "ReviewCompleted":
      return "#4caf50"; // Green - Success
    case "ReviewInProgress":
      return "#2196f3"; // Blue - In Progress
    case "Under Dispute":
      return "#ff9800"; // Orange - Warning
    case "ProcessingFailed":
      return "#f44336"; // Red - Error
    case "ReviewPending":
      return "#9c27b0"; // Purple - Pending
    case "other":
      return "#757575"; // Grey - Other
    default:
      return "#8b83e6"; // Default purple
  }
};
